<template>
  <div>
    <h6>{{ survey.presentation }}</h6>
    <div v-for="(sf, key) in questions" :key="sf.id">
      <OpenAnswerTextArea
        v-if="sf.componentVue === 'OpenAnswerTextArea'"
        :order="key + 1"
        :userDistribution="sf"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
        @setValue="setValue"
      />
      <ZeroToTenScale
        v-if="sf.componentVue === 'ZeroToTenScale'"
        :order="key + 1"
        :userDistribution="sf"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
        :emailValue="key == 0 ? valueSelectedEmail : null"
        @setValue="setValue"
      />
      <LikertIconsScale
        v-if="sf.componentVue === 'LikertIconsScale'"
        :order="key + 1"
        :userDistribution="sf"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
        @setValue="setValue"
      />
      <SatisfactionScale
        v-if="sf.componentVue === 'SatisfactionScale'"
        :order="key + 1"
        :userDistribution="sf"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
        @setValue="setValue"
      />
      <StarIconsScale
        v-if="sf.componentVue === 'StarIconsScale'"
        :order="key + 1"
        :userDistribution="sf"
        :freeField1="sf.field1"
        :freeField2="sf.field2"
        :freeField3="sf.field3"
        @setValue="setValue"
      />
      <hr class="mb-4" />
    </div>
    <div class="text-end">
      <button
        class="btn btn-primary"
        :disabled="disableButton || notAwnsered"
        @click="finishSurvey(survey)"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
import OpenAnswerTextArea from '@/components/params/forms/OpenAnswerTextArea.vue'
import ZeroToTenScale from '@/components/params/forms/ZeroToTenScale.vue'
import LikertIconsScale from '@/components/params/forms/LikertIconsScale.vue'
import SatisfactionScale from '@/components/params/forms/SatisfactionScale.vue'
import StarIconsScale from '@/components/params/forms/StarIconsScale.vue'

export default {
  name: 'StructureSurveyUser',

  props: {
    survey: {
      type: Object,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },

  components: {
    OpenAnswerTextArea,
    ZeroToTenScale,
    LikertIconsScale,
    SatisfactionScale,
    StarIconsScale,
  },

  emits: ['reloadSurvey'],

  data() {
    return {
      valueSelectedEmail: this.$route.query.value,
      questionsMap: [],
      disableButton: false,
      flagValueSelectedEmail: false,
    }
  },

  computed: {
    notAwnsered() {
      return this.questions.some(
        (question) => this.questionsMap[question.id] === null,
      )
    },
  },

  methods: {
    async setValue(item) {
      try {
        const response = await this.$store.dispatch('setAnswer', item)
        if (response && response.status) {
          this.questionsMap[item.id] = item.value
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async finishSurvey() {
      try {
        this.disableButton = true
        await this.$store.dispatch('finishSurvey', this.survey.uuid)
        this.$emit('reloadSurvey')
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.questionsMap = this.questions.reduce((acc, question) => {
      acc[question.id] = question.value
      return acc
    }, {})
  },
}
</script>
